module.exports = __webpack_public_path__ + "media/styles/images/svg/oval-white-1f5a17383881c6fc046abf96f3092df7.svg";